module.exports = __webpack_public_path__ + "static/media/icon-add-group-2.19d02cc4.svg";